import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { UsuarioService } from '../services/usuario.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-trocar-senha',
	templateUrl: './trocar-senha.component.html',
	styleUrls: ['./trocar-senha.component.css'],
	animations: [loadingFade]
})

export class TrocarSenhaComponent implements OnInit {
	public loading;
	public submitting = false;
	public alerta_senha = false;

	public formSenha: FormGroup;

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private usuarioSvc: UsuarioService,
		private router: Router) { }

	ngOnInit() {
		this.criaForm();

		this.loading = false;
	}

	criaForm() {
		this.formSenha = this.fb.group({
			usuario_id: this.authSvc.getUsuarioId(),
			senha_atual: [null, Validators.required],
			senha_nova: [null, Validators.required],
			senha_confirma: [null, Validators.required]
		});
	}

	enviaSenha() {
		if (this.formSenha.valid) {
			this.submitting = true;
			let toSend = this.formSenha.value;
			this.usuarioSvc.trocaSenha(toSend).then((data) => {
				Swal.fire({
					'type':'success',
					'title':"Senha alterada com sucesso!" ,
					onClose: ()=>{
						this.router.navigate(['home']);
				 	}
				});
			}).catch(err => {
				Swal.fire({
					'type':'error',
					'title':"Senha atual incorreta!",
					'allowEscapeKey': false,
					'allowOutsideClick': false
				});
				this.submitting = false;
				console.log(err);
			});
		}
	}

	invalid(nome) {
		let input = this.formSenha.get(nome);
		return input.touched && input.invalid;
	}

	verificaSenha(){
		let senha_nova = this.formSenha.get('senha_nova');
		let senha_confirma = this.formSenha.get('senha_confirma');
		if(senha_nova.value != senha_confirma.value){
			this.alerta_senha = true;
		}
		else{
			this.alerta_senha = false;
		}
	}

	checkPasswords(group: FormGroup) {
		let pass = group.controls.password.value;
		let confirmPass = group.controls.confirmPass.value;
		return pass === confirmPass ? null : { notSame: true }     
	}
}
